export const PAGINATION = { page: 1, size: 10 }

export const COUPON_TYPE = {
  NORMAL_EXPERIENCE: 'NORMAL_EXPERIENCE',
  TASK_EXPERIENCE: 'TASK_EXPERIENCE',
  NORMAL_FEE_DEDUCT: 'NORMAL_FEE_DEDUCT',
  TASK_FEE_DEDUCT: 'TASK_FEE_DEDUCT',
  NORMAL_PNL_DEDUCT: 'NORMAL_PNL_DEDUCT',
  TASK_PNL_DEDUCT: 'TASK_PNL_DEDUCT',
  NORMAL_TOKEN: 'NORMAL_TOKEN',
  TASK_TOKEN: 'TASK_TOKEN',
  NORMAL_POSITION_EXPERIENCE: 'NORMAL_POSITION_EXPERIENCE',
  TASK_POSITION_EXPERIENCE: 'TASK_POSITION_EXPERIENCE',
  TASK_VIP: 'TASK_VIP',
}

const TYPE_LABELS = {
  NORMAL_EXPERIENCE: '普通体验金',
  TASK_EXPERIENCE: '任务体验金',
  NORMAL_FEE_DEDUCT: '普通手续费抵扣券',
  TASK_FEE_DEDUCT: '任务手续费抵扣券',
  NORMAL_PNL_DEDUCT: '普通盈亏抵扣券',
  TASK_PNL_DEDUCT: '任务盈亏抵扣券',
  NORMAL_TOKEN: '普通代币券',
  TASK_TOKEN: '任务代币券',
  NORMAL_POSITION_EXPERIENCE: '普通仓位体验券',
  TASK_POSITION_EXPERIENCE: '任务仓位体验券',
  TASK_VIP: 'VIP体验卡',
}

export const COUPON_TYPE_OPTIONS = Object.keys(TYPE_LABELS).map((value) => ({
  label: TYPE_LABELS[value],
  value,
}))
export const COUPON_TYPE_MAP = TYPE_LABELS

export const isNormalCoupon = (type) => /^NORMAL_/.test(type || '')
export const isTokenCoupon = (type) => /_TOKEN$/.test(type || '')
export const isPositionCoupon = (type) => /_POSITION_EXPERIENCE$/.test(type || '')
export const isVipCoupon = (type) => type === COUPON_TYPE.TASK_VIP
export const hasDeductRate = (type) =>
  /_(EXPERIENCE|FEE_DEDUCT|PNL_DEDUCT)$/.test(type || '') && !isPositionCoupon(type)

export const COUPON_STATUS = {
  WAIT_GRANT: 'WAIT_GRANT',
  GRANTING: 'GRANTING',
  ENDED: 'ENDED',
}
export const COUPON_STATUS_OPTIONS = [
  { label: '全部状态', value: '' },
  { label: '待发放', value: COUPON_STATUS.WAIT_GRANT },
  { label: '发放中', value: COUPON_STATUS.GRANTING },
  { label: '已结束', value: COUPON_STATUS.ENDED },
]
export const COUPON_STATUS_TAG = {
  WAIT_GRANT: { text: '待发放', type: 'warning' },
  GRANTING: { text: '发放中', type: 'success' },
  ENDED: { text: '已结束', type: 'info' },
}

export const COIN_OPTIONS = [{ label: 'USDT', value: 'USDT' }]
